import {StyleSheet} from 'react-native';

export const styles = StyleSheet.create({
  touchable: {
    backgroundColor: '#2196F3',
    height: 50,
    borderRadius: 30,
    paddingVertical: 8,
    paddingHorizontal: 16,
    alignItems: 'center',
  },
  textStyle: {
    flexDirection: 'column',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: 40,
  },
});
